<template>
  <v-app class="body">

    <!--<app-drawer></app-drawer>-->
    <app-toolbar></app-toolbar>
    <app-sub-toolbar></app-sub-toolbar>
    <!--<app-header></app-header>-->

    <v-content>
      <router-view></router-view>
    </v-content>

    <app-footer
            v-if="page.indexOf('malina') != -1 || page.indexOf('sadko') != -1 || page.indexOf('acropolis') != -1"
    ></app-footer>
    <app-malina-button-call
            v-if="page.indexOf('malina') != -1"
    ></app-malina-button-call>
    <app-sadko-button-call
            v-if="page.indexOf('sadko') != -1"
    ></app-sadko-button-call>
    <app-acropolis-button-call
            v-if="page.indexOf('acropolis') != -1"
    ></app-acropolis-button-call>

  </v-app>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {
    page () {
      return this.$route.path
    }
  }
}
</script>

<style>
.body {
    color: #272727;
    font-size: 16px;
}

h1 {
  font-size: 36px;
}

h2 {
  font-size: 24px;
}

h3 {

}

a,
a:hover,
a:visited,
a:active {
  color: #000000;
  text-decoration: none;
}

.screen {
  padding-top: 70px !important; /* с цветным блоком */
  padding-bottom: 70px !important;
}

.screen2 {
  padding-top: 0px !important; /* с белым блоком */
  padding-bottom: 70px !important;
}

.screen3 {
  padding-top: 30px !important; /* с белым блоком - первый*/
  padding-bottom: 70px !important;
}

/* OFFER */
.offer-back {
    height: 80vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}

.offer1-mask {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

.offer1-offer {
  /*color: #89a452;*/
  font-size: 36px;
  margin-top: 15vh;
  margin-bottom: 40px;
  color: white;
}

.offer1-sub-offer {
  font-size: 24px;
  margin: 40px 0px;
  color: white;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  h1 {
    font-size: 22px;
  }

  h2 {
    font-size: 16px;
  }

  .screen {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }

  .screen2 {
    padding-top: 0px !important;
    padding-bottom: 50px !important;
  }

  .screen3 {
    padding-top: 30px !important;
    padding-bottom: 50px !important;
  }

  .offer1-offer {
    font-size: 22px;
    margin-top: 10vh;
  }

  .offer1-sub-offer {
    font-size: 16px;
    margin: 30px 0px;
  }
}

/* SMALL */
@media (max-width: 960px) {
  .body {
      font-size: 14px;
  }
}

/* MEDIUM */
@media (max-width: 1264px) {

}

/* LARGE */
@media (max-width: 1904px) {

}

/* X LARGE */
@media (min-width: 1904px) {

}
</style>



// WEBPACK FOOTER //
// src/App.vue